{
  "nl": {
    "voices": {
      "azure_speech_ada": "Ada (🇬🇧)",
      "azure_speech_andrew": "Andrew (🇺🇸)",
      "azure_speech_ava": "Ava (🇺🇸)",
      "azure_speech_florian": "Florian (🇩🇪)",
      "azure_speech_ollie": "Ollie (🇬🇧)",
      "azure_speech_remy": "Remy (🇫🇷)",
      "azure_speech_seraphina": "Seraphina (🇩🇪)",
      "azure_speech_tristan": "Tristan (🇪🇸)",
      "azure_speech_vivienne": "Vivienne (🇫🇷)",
      "azure_speech_ximena": "Ximena (🇪🇸)",
      "elevenlabs_bill": "Bill (🇩🇪)",
      "elevenlabs_charlie": "Charlie (🇬🇧, 🇪🇸)",
      "elevenlabs_chris": "Chris (🇫🇷)",
      "elevenlabs_daniel": "Daniel (🇬🇧)",
      "elevenlabs_matilda": "Matilda (🇬🇧, 🇩🇪, 🇫🇷, 🇪🇸)",
      "elevenlabs_rachelle": "Rachelle (🇬🇧)",
      "openai_alloy": "Anna",
      "openai_echo": "Finn",
      "openai_fable": "Robin",
      "openai_nova": "Elena",
      "openai_onyx": "Leon",
      "openai_shimmer": "Alex"
    }
  }
}
